
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[slug]",
      function () {
        return require("private-next-pages/resources/[slug].tsx");
      }
    ]);
  